import React from "react";

const RadioContext = React.createContext(undefined);

export const RadioProvider = RadioContext.Provider;
export const RadioConsumer = RadioContext.Consumer;

export default RadioContext;